import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRightCircle } from 'react-bootstrap-icons';

import Link from './link';
import useTranslation from '../../hooks/use_translation';
import BtnIcon from './buttons/btn_icon';

const TableOfContent = ({ items }) => {
	const { t } = useTranslation('component_table_of_content');
	if (!items || !items.length) {
		return <></>;
	}

	return (
		<>
			<div className="bg-light rounded-3 p-3 mt-2">
				<p className="title-xsmall uppercase">{t('t1')}</p>
				<nav>
					<ul className="nav flex-column article-nav">
						{items.map((value, index) => (
							<li className="nav-item" key={index}>
								<BtnIcon
									size="sm"
									iconSize="sm"
									labelSize="xs"
									to={`#${value.id}`}
									variant="gray"
									label={value.text}
								/>
								<hr className="my-1" />
							</li>
						))}
					</ul>
				</nav>
			</div>
		</>
	);
};

TableOfContent.propTypes = {
	items: PropTypes.array,
};

export default TableOfContent;
